module.exports = __webpack_public_path__ + "img/_footer.64b1fb91.png";